///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.workflow = abcsetup.atp_documents.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents.workflow = {

    workflow_task: null,

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Authorized Trading Partner');
        abcsetup.atp_documents.common.bindFormElems();

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.atp_documents.workflow._rejectItem($(this));
        });

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        $('#app_models_a_t_p_document__signature').val('');

        $(document).on('change', '#app_models_a_t_p_document__fda_identifiers', function(e) {
            let feiNumber = $(this).val();

            $('.btn-success').prop('disabled', false);

            // Disabling EIN validation per https://retailinsightsllc.atlassian.net/browse/ABCS-3562
            /*
            if (feiNumber != '') {
                setTimeout(() => {
                    abcsetup.blockUI(true);
                }, 250);

                axios.get('/atp_documents/validate_ein', {
                        'params': {
                            'fei_number': feiNumber
                        }
                    })
                    .then(response => {
                        let color = 'red';

                        if (response.data.status == 'success') {
                            color = 'green';
                            $('.btn-success').prop('disabled', false);
                        } else {
                            $('.btn-success').prop('disabled', true);
                        }

                        $('#alerts-modal .modal-body').css({'color': color});
                        $('#alerts-modal-dismiss-button').text('Proceed');

                        abcsetup.unblockUI();

                        abcsetup.alerts.show('FEI Number Status', response.data.message);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            */
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Signature invite button
        $(document).on('click', '.btn-signature-invite', function () {
            var _link = $(this);
            _link.css("cursor", "progress");

            axios.post('/api/atp_documents/send_signature', {
                'tag': _link.data('field-tag'),
                'column': _link.data('field-column'),
                'email': _link.closest('.row').find('input').val(),
                'workflow_task_id': abcsetup.atp_documents.workflow.workflow_task.id,
            }).then(response => {
                _link.css('cursor', 'pointer');
                abcsetup.alerts.show('Signature Email Sent', 'We\'ve sent a signature request email to the address you specified.');
            });
        });
    },

    /**
     * Reject the item
     */
    _rejectItem: function (btn) {

        // We don't have a reject reason
        if (!$(':checkbox[name^="reject_reason"]').length) {
            btn.unbind('click').attr('type', 'submit').trigger('click');
        }

        // We have multiple rejection reasons
        if ($(':checkbox[name^="reject_reason"]').length > 1) {
            if ($(':checkbox[name^="reject_reason"]:checked').length == 0) {
                abcsetup.alerts.show('Reject ATP Document', 'Please specify a rejection reason.');
                return false;
            }

        } else {
            //const rejectReasonField = $('textarea[name="reject_reason"].required') || $('textarea[name="reject_reason_text[other]"].required');
            const rejectReasonField = $('textarea[name="reject_reason"].required');

            if (!rejectReasonField.val()) {
                rejectReasonField.addClass('error');
                return false;
            }
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
    },

}
